/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 0
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VehicleHighlightFromJSON, VehicleHighlightToJSON, } from './VehicleHighlight';
import { HeadingFromJSON, HeadingToJSON, } from './Heading';
import { DescriptionFromJSON, DescriptionToJSON, } from './Description';
import { ContactDetailsFromJSON, ContactDetailsToJSON, } from './ContactDetails';
import { FeaturesWithDisclaimerFromJSON, FeaturesWithDisclaimerToJSON, } from './FeaturesWithDisclaimer';
import { RunningCostsFromJSON, RunningCostsToJSON, } from './RunningCosts';
import { FeatureByCategoryFromJSON, FeatureByCategoryToJSON, } from './FeatureByCategory';
import { FinanceFromJSON, FinanceToJSON, } from './Finance';
import { SpecByCategoryFromJSON, SpecByCategoryToJSON, } from './SpecByCategory';
import { SpecFromJSON, SpecToJSON, } from './Spec';
import { FeatureHighlightsByCategoryFromJSON, FeatureHighlightsByCategoryToJSON, } from './FeatureHighlightsByCategory';
/**
 * Check if a given object implements the Advert interface.
 */
export function instanceOfAdvert(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('keySpecification' in value) || value['keySpecification'] === undefined)
        return false;
    if (!('specs' in value) || value['specs'] === undefined)
        return false;
    return true;
}
export function AdvertFromJSON(json) {
    return AdvertFromJSONTyped(json, false);
}
export function AdvertFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'contactDetails': json['contactDetails'] == null ? undefined : ContactDetailsFromJSON(json['contactDetails']),
        'heading': json['heading'] == null ? undefined : HeadingFromJSON(json['heading']),
        'description': json['description'] == null ? undefined : DescriptionFromJSON(json['description']),
        'overview': json['overview'] == null ? undefined : (json['overview'].map(SpecFromJSON)),
        'keySpecification': (json['keySpecification'].map(SpecFromJSON)),
        'features': json['features'] == null ? undefined : (json['features'].map(FeatureByCategoryFromJSON)),
        'featuresHighlights': json['featuresHighlights'] == null ? undefined : (json['featuresHighlights'].map(FeatureHighlightsByCategoryFromJSON)),
        'vehicleHighlights': json['vehicleHighlights'] == null ? undefined : (json['vehicleHighlights'].map(VehicleHighlightFromJSON)),
        'specs': (json['specs'].map(SpecByCategoryFromJSON)),
        'featuresWithDisclaimer': json['featuresWithDisclaimer'] == null ? undefined : FeaturesWithDisclaimerFromJSON(json['featuresWithDisclaimer']),
        'runningCosts': json['runningCosts'] == null ? undefined : RunningCostsFromJSON(json['runningCosts']),
        'finance': json['finance'] == null ? undefined : FinanceFromJSON(json['finance']),
    };
}
export function AdvertToJSON(json) {
    return AdvertToJSONTyped(json, false);
}
export function AdvertToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'contactDetails': ContactDetailsToJSON(value['contactDetails']),
        'heading': HeadingToJSON(value['heading']),
        'description': DescriptionToJSON(value['description']),
        'overview': value['overview'] == null ? undefined : (value['overview'].map(SpecToJSON)),
        'keySpecification': (value['keySpecification'].map(SpecToJSON)),
        'features': value['features'] == null ? undefined : (value['features'].map(FeatureByCategoryToJSON)),
        'featuresHighlights': value['featuresHighlights'] == null ? undefined : (value['featuresHighlights'].map(FeatureHighlightsByCategoryToJSON)),
        'vehicleHighlights': value['vehicleHighlights'] == null ? undefined : (value['vehicleHighlights'].map(VehicleHighlightToJSON)),
        'specs': (value['specs'].map(SpecByCategoryToJSON)),
        'featuresWithDisclaimer': FeaturesWithDisclaimerToJSON(value['featuresWithDisclaimer']),
        'runningCosts': RunningCostsToJSON(value['runningCosts']),
        'finance': FinanceToJSON(value['finance']),
    };
}
